import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LiftComponent } from './lift/lift.component';
import { LiftenComponent } from './liften/liften.component';

const routes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'liften', component: LiftenComponent },
    { path: 'lift/:liftnr/:sessID', component: LiftComponent },
    { path: 'lift/:liftnr', component: LiftComponent },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
